/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyEthereum = createReactComponent("outline", "currency-ethereum", "IconCurrencyEthereum", [["path", { "d": "M6 12l6 -9l6 9l-6 9z", "key": "svg-0" }], ["path", { "d": "M6 12l6 -3l6 3l-6 2z", "key": "svg-1" }]]);

export { IconCurrencyEthereum as default };
//# sourceMappingURL=IconCurrencyEthereum.mjs.map
